import { useEffect } from 'react';
import { componentFrameworkStore } from '@provider/component-framework';
import { useNotifier } from '@provider/notifier';
import { usePlatformIOS } from '@utils/common';
import { useFullscreenState } from '@utils/react';

let offsetFromTopOnEnter = 0;
function handleExitFullscreenClick(notifier) {
  componentFrameworkStore.dispatch(componentFrameworkStore.actions.setOverlayContainer(undefined));
  const fullscreenChangePromise = document.documentElement.requestFullscreen !== undefined ? document.exitFullscreen() :
  // @ts-expect-error bad typings
  document.webkitExitFullscreen();
  Promise.resolve(fullscreenChangePromise).catch(() => {
    notifier.notify({
      id: "fullscreen.error",
      type: "error",
      body: "Vi kunne ikke lukke indholdet"
    });
  });
}
function useFullscreenActions(args) {
  const notifier = useNotifier();
  const {
    fullscreenSupported,
    fullscreenEnabled
  } = useFullscreenState();
  const isIOS = usePlatformIOS();
  const handleFullscreenClick = async () => {
    await args.onFullscreenOpen?.();

    // iOS iPads do not handle fullscreen gracefully as they forcibly close the
    // fullscreen whenever an input is focussed. As such we fall back to
    // lightboxes.
    if (isIOS || !fullscreenSupported) {
      args.handleOpenInLightboxFallback();
      return;
    }
    offsetFromTopOnEnter = document.scrollingElement?.scrollTop;
    componentFrameworkStore.dispatch(componentFrameworkStore.actions.setOverlayContainer(`[id="${args.overlayId}"]`));
    const target = document.querySelector(args.rootSelector) ?? document.documentElement;
    const fullscreenChangePromise = target.requestFullscreen !== undefined ? target.requestFullscreen() :
    // @ts-expect-error bad typings
    target.webkitRequestFullscreen();
    Promise.resolve(fullscreenChangePromise).catch(reason => {
      notifier.notify({
        id: "fullscreen.error",
        type: "error",
        body: "Vi kunne ikke åbne indholdet i fuldskærmsvisning"
      });
      console.error(reason);
    });
  };
  useEffect(() => {
    if (offsetFromTopOnEnter && !fullscreenEnabled) {
      componentFrameworkStore.dispatch(componentFrameworkStore.actions.setOverlayContainer(undefined));
      setTimeout(() => {
        if (offsetFromTopOnEnter) {
          document.scrollingElement?.scrollTo({
            top: offsetFromTopOnEnter
          });
        }

        // If multiple items are embedded on the same page, then they will all
        // attempt to trigger scroll restoration. Ensure that all access the
        // correct offsetFromTopOnEnter before resetting it.
        setTimeout(() => {
          offsetFromTopOnEnter = 0;
        });

        // Add a short delay before triggering scroll restoration in order to
        // avoid issues with browser built-in animation.
      }, 25);
    }
  }, [fullscreenEnabled]);
  return {
    handleFullscreenClick,
    handleExitFullscreenClick: () => handleExitFullscreenClick(notifier)
  };
}

export { handleExitFullscreenClick, useFullscreenActions };
//# sourceMappingURL=fullscreen.actions.js.map
